.container {
  position: relative;
  width: 100%;
}

.input {
  width: 100%;
}

.dropdown {
  position: absolute;
  top: calc(100% + map.get($spacing-scale, 's-3'));
  left: 0;
  right: 0;
  z-index: 100;
}

.noResults {
  background-color: var(--color-surface-primary);
  border-radius: map.get($radius, 'md');
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  padding: map.get($spacing-scale, 'lg');
  text-align: center;
  color: var(--color-text-secondary);

  @include body-small-regular;
}
